import { Link } from "react-router-dom";

const NotFound = () => (
  <section
    data-testid="not-found-page"
    className="min-h-[70vh] flex items-center justify-center px-6"
  >
    <div className="text-center max-w-md">
      <div className="text-xs uppercase tracking-[0.25em] text-amber-600 font-medium mb-3">
        404
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-[#0B1B3D] tracking-tight">
        Signal lost.
      </h1>
      <p className="mt-3 text-slate-600 leading-relaxed">
        The page you're looking for isn't in orbit. Let's get you back on course.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-2 bg-[#0B1B3D] hover:bg-[#1E3A8A] text-white font-medium px-5 py-3 rounded-md"
      >
        Return home
      </Link>
    </div>
  </section>
);

export default NotFound;
